import React, { useState, useEffect, Fragment } from "react";
import LeadDetailsApt from "components/sales/formSection/leadDetails/leadDetailsApt";
import PocDetails from "components/sales/formSection/pocDetails/pocDetails";
import Location from "components/sales/formSection/location/locationOnboarding";
import CategoryDetails from "components/sales/formSection/categoryDetails/categoryDetails";
import CategoryDetailsCorp from 'components/sales/formSection/categoryDetails/categoryDetailsCorp';
import LeadDetailsSupply from "components/sales/formSection/leadDetails/leadDetailsSupply";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { useContext } from "react";
import BulkUpload from "components/sales/bulkUpload/bulkUpload";
import LeadDetails from 'components/sales/formSection/leadDetails/leadDetails';
import './form.css';
const AddProjectOnboardingForm = ({
                        locationCity,
                        cities,
                        locationZone,
                        zones,
                        locationArea,
                        areas,
                        locationType,
                        locTypesData,
                        locationState,
                        createApartmentLead,
                        locationPinCode,
                        pincodeData,
                        rwaTenureFun,
                        rwaTenureData,
                        appartmentDropDown,
                        getApartmentDropDown,
                        getCurrentLocation,
                        latlng,
                        toastMsg,
                        BulkUploadLead,
                        getSampleFileLead,
                        sampleData,
                        projectType,
                        projectSubType,
                        project_name,
                        lat,
                        lng,
                        corDropDownData,
                        createProjectOnboarding,
                        splNameData,
                        supplyNameFun,
                        supDropDownData,
                        documentUploadUrl,
                        documentUrlData,
                        pocSubSiteTypeData,
                        pocSubSiteType,
                        currentLocation,
                    }) => {
    const corporateInput = {
        leadDetails: null,
        pocDetails: null,
        location: null,
        categoryDetails: null,
        gateDetails: null
    };

    const { baseUrl } = useContext(BaseUrl);
    const [isModal, setIsModal] = useState(false);
    const [corporateData, setCorporateData] = useState(corporateInput);
    const [isFiled, setIsFiled] = useState(false);
    const [isbulk, setIsbulk] = useState(false);
    const [isUploaded, setIsuploaded] = useState(false);
    const [bulkFile, setBulkFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isDefalut, setIsDefalut] = useState(false);
    const [isSupply, setIsSupply] = useState(false);
    const [isApt, setIsApt] = useState(false);
    const [dropdown, setDropDown] = useState();

    useEffect(() => {
        if (appartmentDropDown) {
            setDropDown(appartmentDropDown);
        }
    }, [appartmentDropDown]);

    useEffect(() => {
        if(projectType == 1){
            setIsSupply(false);
            setIsApt(false);
        }else if (projectType == 2){
            setIsSupply(false);
            setIsApt(true);
        }else{
            setIsSupply(true);
            setIsApt(false);
        }
    },[projectType])

    const handleLeadSubmit = (val) => {
        setCorporateData({ ...corporateData, leadDetails: val });
        setIsDefalut(false);
    };
    const handlePocSubmit = (val) => {
        setCorporateData({ ...corporateData, pocDetails: val });
        setIsDefalut(false);
    };
    const handleLocSubmit = (val) => {
        setCorporateData({ ...corporateData, location: val });
        setIsDefalut(false);
    };
    const handleCatSubmit = (val) => {
        // console.log(val);
        setCorporateData({ ...corporateData, categoryDetails: val });
        setIsDefalut(false);
    };
    const handleGatesSubmit = (val) => {
        setCorporateData({ ...corporateData, gateDetails: val });
        setIsDefalut(false);
    };

    const handleModalHide = async () => {
        setCorporateData(corporateInput);
        await getApartmentDropDown();
        setIsDefalut(true);
        setIsModal(false);
    };

    useEffect(() => {
        (async()=>{
            await getSampleFileLead();
        })();
    }, [getSampleFileLead])

    const handleSubmit = () => {
        console.log(corporateData);
        console.log('submit!');
        const {
            leadDetails,
            pocDetails,
            location,
            categoryDetails,
            gateDetails
        } = corporateData;
        if (
            leadDetails === null ||
            location === null ||
            pocDetails === null
            // categoryDetails === null
        ) { 
            setIsFiled(true);
            setIsModal(false);
            return false;
        } else { 
            setIsFiled(false);
            (async () => {
                setIsLoading(true);
                const res = await createProjectOnboarding({
                    ...leadDetails,
                    ...pocDetails,
                    ...location,
                    ...categoryDetails,
                    ...gateDetails,
                    projectType,
                    projectSubType,
                    project_name,
                    lat,
                    lng,
                    currentLocation
                });
                setIsLoading(false);
                localStorage.removeItem("currentLocation");
                if (res) {
                    setIsModal(true);
                }
            })();
        }
    };

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await getApartmentDropDown();
            setIsLoading(false);
        })();
    }, [getApartmentDropDown]);

    const handlebulkSubmit = async () => {
        if (bulkFile !== null) {
            const res = await BulkUploadLead(bulkFile);
            if (res) {
                setIsuploaded(true);
            } else {
                setIsuploaded(false);
            }
        }
    };
    const handleFileChange = (val) => setBulkFile(val);

    const headerBtns = () => {
        return (
            <Fragment>
                <Button onClick={() => setIsbulk(true)} className="btn btn-transparent">
                    {localization.bulkUpload}
                </Button>
            </Fragment>
        );
    };

    return (

        <>
        { projectType == 2  ? 
            <LeadDetailsApt
                inputLabel={localization.clientAprtname}
                handleValue={handleLeadSubmit}
                isApartment={true}
                appartmentDropDown={dropdown}
                isDefalut={isDefalut}
                client_name={project_name}
                documentUploadUrl={documentUploadUrl}
            />
            :null}
            {projectType == 1  ? 
                <LeadDetails
                inputLabel={localization.clientName}
                isCorporate={true}
                corDropDownData={corDropDownData}
                handleValue={handleLeadSubmit}
                isDefalut={isDefalut}
                client_name={project_name}
            />
            :null}
            {projectType == 4 ?  
             <LeadDetailsSupply
                    inputLabel={localization.clientName}
                    isSupply={true}
                    handleValue={handleLeadSubmit}
                    pocSubSiteTypeData={pocSubSiteTypeData}
                    pocSubSiteType={pocSubSiteType}
                    supDropDownData={supDropDownData}
                    isDefalut={isDefalut}
                    client_name={project_name}
                    documentUploadUrl={documentUploadUrl}
                />
                :null}
                {/* {projectType == 1 ? 
            <LeadDetails
                inputLabel={localization.clientName}
                isCorporate={true}
                corDropDownData={corDropDownData}
                handleValue={handleLeadSubmit}
                isDefalut={isDefalut}
            /> : null } */}
            <PocDetails
                handleValue={handlePocSubmit}
                appartmentDropDown={dropdown}
                isDefalut={isDefalut}
                projectType={projectType}
            />
            <Location
                locationCity={locationCity}
                cities={cities}
                locationZone={locationZone}
                zones={zones}
                locationArea={locationArea}
                areas={areas}
                locationType={locationType}
                locTypesData={locTypesData}
                handleValue={handleLocSubmit}
                locationState={locationState}
                locationPinCode={locationPinCode}
                pincodeData={pincodeData}
                getCurrentLocation={getCurrentLocation}
                latlng={latlng}
                toastMsg={toastMsg}
                isDefalut={isDefalut}
                lat={lat}
                lng={lng}
                currentLocation={currentLocation}
            />
            {projectType == 2 ? 
                <CategoryDetails
                isApartments={isApt}
                isSupply={isSupply}
                handleValue={handleCatSubmit}
                corDropDownData={corDropDownData}
                rwaTenureFun={rwaTenureFun}
                rwaTenureData={rwaTenureData}
                appartmentDropDown={dropdown}
                isDefalut={isDefalut}
            />: null
            }
            
            {projectType === 1 ? 
                <CategoryDetailsCorp
                isSupply={false}
                handleValue={handleCatSubmit}
                supplyNameFun={supplyNameFun}
                splNameData={splNameData}
                rwaTenureFun={rwaTenureFun}
                rwaTenureData={rwaTenureData}
                corDropDownData={corDropDownData}
                isDefalut={isDefalut}
                />
                :null}

           
                {projectType === 4 && projectSubType !== 9 && projectSubType !== 4 ? 
                            <CategoryDetails
                                    isSupply={true}
                                    supDropDownData={supDropDownData}
                                    handleValue={handleCatSubmit}
                                    isDefalut={isDefalut}
                                    projectSubType={projectSubType}
                                    documentUploadUrl={documentUploadUrl}
                                    documentUrlData={documentUrlData}
                                />
                                :null
                }


            {/* <GatesForm
        gateType={rwaTenureData.gateType}
        handleValue={handleGatesSubmit}
        isDefalut={isDefalut}
      /> */}
            <Fragment>
                <div className="btn-group">
                    <Button
                        onClick={handleSubmit}
                        className="d-none d-md-inline-block
         d-md-none d-block xs-fullwidth btncrp submit-dtl-btn"
                    >
                        <div className="submit-dtl-btn">
                            {localization.submitDtl}
                        </div>
                        <img src={Images?.ArrowRight} alt="" />
                    </Button>
                </div>
            </Fragment>

            <BulkUpload
                sampleData={sampleData && sampleData}
                handleModalHide={() => setIsbulk(!isbulk)}
                handlebulkSubmit={handlebulkSubmit}
                isbulk={isbulk}
                handleFileChange={handleFileChange}
                isUploaded={isUploaded}
            />
            <ModalPop
                title={localization.conf}
                show={isModal}
                handleModalHide={handleModalHide}
                keyboard
                backdrop
            >
                <div className="text-center">
                    <div className="success">
                        <img src={Images?.tick} alt="" />
                    </div>
                    <h5>{localization.leadSuccess}</h5>
                    <Link
                        to={`${baseUrl}/project-onboarding/list`}
                        className="btn btn-primary mb-4"
                    >
                       Project List <img src={Images?.ArrowRight} alt="" />
                    </Link>
                    {/* <Button onClick={handleModalHide} className="btn btn-transparent">
                        {localization.createAnother}
                        <img src={Images?.ArrowRight} alt="" />
                    </Button> */}
                </div>
            </ModalPop>
        </>
    );
};

export default AddProjectOnboardingForm;
